import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { RfpContainer } from '@/components/modules/pages/rfp/Layout/RfpContainer/RfpContainer';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer';
import { Stepper } from '@/components/ui/Navigation/Stepper';
import { BandHead } from '@/components/ui/Typography/Heading/BandHead';
import { professionalRfpListPath, professionalRfpOnePath, myPagePath, } from '@/utils/router/links';
export const STEP_TYPE_OFFER = 'offer';
export const STEP_TYPE_OFFER_PAYMENT = 'payment';
export const STEP_TYPE_OFFER_CONFIRM = 'confirm';
export const STEP_TYPE_OFFER_COMPLETE = 'complete';
export const STEP_TYPE_OFFERED = 'offered';
const steps = ['提案内容を入力', '支払情報を入力', '入力内容の確認', '提案完了'];
export const RfpProOfferLayout = (props) => {
    const { children, className = '', loading = false, rfpId, rfpName = '', stepType, } = props;
    const isOffered = useMemo(() => stepType === STEP_TYPE_OFFERED, [stepType]);
    const stepIndex = useMemo(() => {
        switch (stepType) {
            case STEP_TYPE_OFFER:
                return 0;
            case STEP_TYPE_OFFER_PAYMENT:
                return 1;
            case STEP_TYPE_OFFER_CONFIRM:
                return 2;
            default:
                return 3;
        }
    }, [stepType]);
    const stepName = useMemo(() => (isOffered ? `${rfpName} 入力内容の確認` : steps[stepIndex]), [isOffered, rfpName, stepIndex]);
    /** パンくず */
    const breadcrumbs = useMemo(() => [
        {
            link: myPagePath(),
            text: 'マイページ',
        },
        {
            link: professionalRfpListPath(),
            text: '募集中のプロジェクト',
        },
        {
            link: rfpId ? professionalRfpOnePath(rfpId) : '',
            text: rfpName,
        },
        { text: stepName },
    ], [rfpId, rfpName, stepName]);
    return (_jsxs(RfpContainer, Object.assign({ breadcrumbs: breadcrumbs, className: className, isFull: true, titleComponent: _jsx(BandHead, Object.assign({ bgColor: 'primary', className: 'lg:text-center !px-0', fixTextPosition: 'left', textClassName: clsx(loading && '!leading-[0px]') }, { children: _jsx(ContentContainer, Object.assign({ className: 'mx-auto' }, { children: loading ? (_jsx(Skeleton, { className: 'inline-block w-full h-[27px]' })) : (_jsx("span", { children: rfpName })) })) })) }, { children: [_jsx("div", Object.assign({ className: 'w-full max-w-[240px] sm:max-w-[528px] mx-auto mt-24 sm:mt-36' }, { children: _jsx(Stepper, { currentIndex: stepIndex, loading: loading, stepTexts: steps }) })), children] })));
};
